import { render, staticRenderFns } from "./safe-list.vue?vue&type=template&id=16ac5f18&scoped=true"
import script from "./safe-list.vue?vue&type=script&lang=js"
export * from "./safe-list.vue?vue&type=script&lang=js"
import style0 from "./safe-list.vue?vue&type=style&index=0&id=16ac5f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac5f18",
  null
  
)

export default component.exports